import React, { Component } from "react";
import { Menu } from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        let current = 'siteClose';
        if (props.selectKey) {
            current = props.selectKey;
        }
        this.state = { current };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render() {
        const { current } = this.state;
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe62c;</i><span>项目关闭</span></span>}>
                        <Menu.Item key="siteClose">
                            <a href="#/shutOff/siteClose">中心关闭记录</a>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/invShutOff/SideNav.js